import * as THREE from 'three'
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js'

export class LanternLoader {
  constructor() {
    this.loader = new GLTFLoader()
    this.textureLoader = new THREE.TextureLoader()
  }

  async load(ropePath, lanternPath) {
    const ropeData = await this._loadGLB(ropePath)
    const lanternData = await this._loadGLB(lanternPath)

    const ropeGroup = ropeData.scene.clone()
    const anchors = []

    ropeData.scene.traverse((child) => {
      if (child.isObject3D && !child.isMesh && !child.isLight && !child.isCamera) {
        if (child.children.length === 0 || child.name.toLowerCase().includes('empty') || child.name.toLowerCase().includes('anchor')) {
          const worldPos = new THREE.Vector3()
          child.getWorldPosition(worldPos)
          const worldQuat = new THREE.Quaternion()
          child.getWorldQuaternion(worldQuat)
          anchors.push({ position: worldPos, quaternion: worldQuat })
        }
      }
    })

    console.log(`Found ${anchors.length} lantern anchors`)

    // Preserve full hierarchy (cage + lantern meshes)
    const lanternTemplate = lanternData.scene.clone()

    // Load all mask textures
    const maskPaths = [
      '/sect01/lantern_mask_a.webp',
      '/sect01/lantern_mask_b.webp',
      '/sect01/lantern_mask_c.webp',
      '/sect01/lantern_mask_d.webp'
    ]

    const maskTextures = maskPaths.map((path) => {
      const tex = this.textureLoader.load(path)
      tex.colorSpace = THREE.NoColorSpace
      tex.flipY = false
      return tex
    })

    const palette = [
      new THREE.Color("rgb(255, 29, 123)"),
      new THREE.Color("rgb(255, 174, 0)"),
      new THREE.Color("rgb(29, 172, 255)")
    ]

    const lanternTemplates = palette.map((color) => {
      const template = lanternData.scene.clone()
      template.traverse((child) => {
        if (child.isMesh && child.name === 'lantern') {
          child.material = new THREE.MeshStandardMaterial({
            color: 0x000000,
            emissive: color,
            emissiveMap: maskTextures[0],
            emissiveIntensity: 3
          })
        }
      })
      return template
    })

    console.log('Lantern templates ready')

    return { ropeGroup, anchors, lanternTemplates, maskTextures }
  }

  _loadGLB(path) {
    return new Promise((resolve, reject) => {
      this.loader.load(path, resolve, undefined, reject)
    })
  }
}
